// extracted by mini-css-extract-plugin
export default {"title":"DeleteAccountPage_title__5rnhQ","container":"DeleteAccountPage_container__DFXTc","text":"DeleteAccountPage_text__FuQhX"};